export enum PricingDistributionBaseType {
  PREMIUM_DISCOUNT_ANALYSIS = 'Premium Discount Analysis',
}
